var _rect, _rect2, _path, _path2, _path3, _use, _use2, _use3, _use4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 4320 2880",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ed2939",
    width: 4320,
    height: 1440
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    y: 1440,
    width: 4320,
    height: 1440
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M 1481.678,720 A 541.5,541.5 0 1 1 398.67798,720 A 541.5,541.5 0 1 1 1481.678,720 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed2939",
    d: "M 1651.835,720 A 511.73499,511.73499 0 1 1 628.36499,720 A 511.73499,511.73499 0 1 1 1651.835,720 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "star",
    d: "M 1007.1951,733.06439 L 933.63466,676.63425 L 860.09279,733.09117 L 888.40587,642.09687 L 814.61147,586.0053 L 905.6704,586.1981 L 933.6049,495.07467 L 961.56934,586.18798 L 1052.6282,585.96246 L 978.8522,642.0808 L 1007.1951,733.06439 z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(577.18853,0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(288.88853,-214.21117)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(107.99953,342.74883)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(469.18853,342.74883)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSg);
export default __webpack_public_path__ + "static/media/sg.073c5fc31eb8013c425de85d9b3a9ad6.svg";
export { ForwardRef as ReactComponent };